import deliveryPromisesSaga from '../../deliveryPromise/sagas/DeliveryPromiseSaga';
const loadDeliveryPromiseModule = () => ({
    id: 'DeliveryPromise',
    sagas: [deliveryPromisesSaga],
});
export default loadDeliveryPromiseModule;
